import { render, staticRenderFns } from "./SearchResultsRecord.vue?vue&type=template&id=3aa13636"
import script from "./SearchResultsRecord.vue?vue&type=script&lang=js"
export * from "./SearchResultsRecord.vue?vue&type=script&lang=js"
import style0 from "./SearchResultsRecord.vue?vue&type=style&index=0&id=3aa13636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports